var invokeCallback = function( callback, args ){
    return this[callback](args);
}


var _promanaX = function(route,packet,withHeaders){

    $('.promana-formfield-error').html('');

    if( withHeaders !== false ){

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

    }

    $.ajax({
        url:        route,
        type:       typeof packet._method == 'undefined' ? 'POST' : packet._method,
        cache:      false,
        dataType:   'json',
        data:       packet,
        success:    function(returned){
            msg = returned.action.message;
            if( returned.outcome=='FAIL'){
                invokeCallback( msg.callback, msg.with );
                if(typeof returned.action.route !== "undefined"){
                    setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                }
            }
            if( returned.outcome=='PASS'){
                if(msg.callback.length){
                    invokeCallback( msg.callback, msg.with );
                }
                if(typeof returned.action.route !== 'undefined'){
                    setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                }
            }
        },
        error: function(data){
            $(".promana-survey-spinner-bg").addClass("d-none");
            returned = data.responseJSON;
            var content;
            if(typeof returned.message !== "undefined" && returned.message == "CSRF token mismatch."){
            }else{
                $.each( returned.errors, function( key, value ) {
                    $('#error-'+key).html('<span class="form-text text-danger"><i class="icon-cancel-circle2 mr-2"></i>'+value[0]+'</span>');
                    content = value[0];
                });
                alert( content );
            }
        }
    });
}

var Popups = function () {
    // Custom tooltip color
    var _tooltipCustomColor = function() {
		$('[data-popup=tooltip-custom]').tooltip({
			template: '<div class="tooltip"><div class="arrow border-teal"></div><div class="tooltip-inner bg-teal text-white"></div></div>'
		});
    };

    return {
        init: function() {
            _tooltipCustomColor();
        }
    }
}();

var Legals = function () {

    var _remoteLegalRender = function() {
        $("#modal_legal_terms").on("show.bs.modal", function() {
            $(this).find(".modal-body").load("/terms-of-service");
        });
        $("#modal_legal_privacy").on("show.bs.modal", function() {
            $(this).find(".modal-body").load("/privacy-policy");
        });
    };

    return {
        init: function() {
            _remoteLegalRender();
        }
    }
}();

var FormLayouts = function() {

    // Uniform
    var _componentUniform = function() {
        if (!$().uniform) {
            console.warn('Warning - uniform.min.js is not loaded.');
            return;
        }

        // Initialize
        $('.form-input-styled').uniform({
            fileButtonClass: 'action btn btn-light'
        });
    };

    return {
        init: function() {
            // _componentSelect2();
            _componentUniform();
        }
    }
}();

var Plyrs = function(){

    var _initPlyr = function(){
        

        var player = new Plyr('.promana-plyr');
    }

    return {
        init: function(){
            _initPlyr();
        }
    }
}();

document.addEventListener("DOMContentLoaded", function() {
    Legals.init();
    Popups.init();
    FormLayouts.init();
});

$(document).ready(function(){
    // Plyrs.init();

});
